import { render, staticRenderFns } from "./ObjectivesView.vue?vue&type=template&id=6d8a15c5&scoped=true&"
import script from "./ObjectivesView.vue?vue&type=script&lang=js&"
export * from "./ObjectivesView.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivesView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ObjectivesView.vue?vue&type=style&index=1&id=6d8a15c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8a15c5",
  null
  
)

export default component.exports